const formatNumber = (value: number) => value.toLocaleString("en-US");

const usageColorScheme = (pct: number) => {
  if (pct >= 100) return "red";
  if (pct >= 90) return "orange";
  if (pct >= 75) return "yellow";
  return "green";
};

export { formatNumber, usageColorScheme };
